<template>
  <div class="master mx-4">
    <v-row align="center">
      <v-col cols="auto" class="mr-5" @click="selectMaster">
        <v-menu bottom :offset-y="true">
          <template v-slot:activator="{ on, attrs }">
            <v-row align="center" v-bind="attrs" v-on="on">
              <v-col>
                <v-row dense>
                  <img
                    class="master-account"
                    :src="require(`@/assets/icons/material/customer-account.svg`)"
                    alt="master-account"
                  >
                </v-row>
              </v-col>
              <v-col cols="auto">
                <v-row>
                  <span :class="getMasterAccounts.length > 1 ? ' master-name drop-down' : 'master-name'">
                    {{ getSelectedMasterAccount.name }}
                  </span>
                </v-row>
              </v-col>
            </v-row>
          </template>
          <v-list v-if="getMasterAccounts.length > 1">
            <v-list-item
              v-for="(account, i) in getMasterAccounts"
              :key="i"
              @click="selectMaster(account)"
            >
              <v-list-item-title>{{ account.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import { MasterAccountInfo } from 'ctp-user-auth-service';
import './styles/master-component.scss';
import { onMounted, computed } from 'vue';
import useStore from '@/utils/store/common';

const store = useStore();
const getSelectedMasterAccount = computed(() => store.getters['user/getSelectedMasterAccount']);
const getMasterAccounts = computed(() => store.getters['user/getMasterAccounts']);

onMounted(async () => {
  await store.dispatch('user/listMasterAccounts');
  await store.dispatch('tollDomain/fetchVariants');
});

function selectMaster(account: MasterAccountInfo) {
  store.dispatch('user/setMasterAccount', account);
}
</script>
